function NovaPoshtaMain() {

  const endpointNP        = 'https://api.novaposhta.ua/v2.0/json/';
  const country           = 'Ukraine';
  const provider          = 'Нова пошта';
  const quickIndices      = NP.quickCityIndices.split(' ');
  const bodyNP            = document.getElementById('nova-poshta');
  const deliveryVariants  = document.getElementById('deliveryVariants');
  const deliveryTypes     = document.querySelectorAll('input[type="radio"][name="id"]');
  let deliveryType        = document.querySelector('input[type="radio"][name="id"]:checked').getAttribute('data-type');
  // Wraps
  const wrapWarehouse     = document.querySelector('.warehouse-wrap');
  const wrapAddresses     = document.querySelector('.address-wrap');
  
  // Inputs
  const listCity          = document.querySelector('#city_filter');
  const inputCity         = document.querySelector('[list="city-search"]');
  const listWarehouse     = document.querySelector('#warehouse_filter');
  const inputWarehouse    = document.querySelector('[list="warehouse-search"]');
  const inputStreet       = document.getElementById('address-street');
  const inputBuild        = document.getElementById('address-build');
  const inputFlat         = document.getElementById('address-flat');
  const inputFields       = document.querySelectorAll('.form-group input');
  const filterFields      = document.querySelectorAll('.dropdown-filter');
  const cityErrorEl       = document.querySelector('.city-wrap .input-error');
  const warehouseErrorEl  = document.querySelector('.warehouse-wrap .input-error');
  const streetErrorEl     = document.querySelector('.address-wrap .input-error');
  const clearCity         = document.querySelector('.city-wrap .clear');
  const clearWarehouse    = document.querySelector('.warehouse-wrap .clear');
  const clearStreet       = document.querySelector('.form-street .clear');

  const properties = { _provider: provider, _country: country };

  const properties_all_cart = {
    _provider: '', _country: null, _delivery_courier_address: null, _delivery_courier_street: null,
    _delivery_courier_house: null, _delivery_courier_flat: null, _delivery_street_Ref: null,
    _delivery_city: null, _delivery_city_name: null, _delivery_city_Area: null, _delivery_city_Ref: null,
    _delivery_warehouse: null, _delivery_warehouse_zip: null, _delivery_warehouse_name: null,
    _delivery_warehouse_address: null, _delivery_warehouse_CityRef: null, _delivery_warehouse_Number: null,
    _delivery_warehouse_Ref: null, _delivery_warehouse_SettlementRef: null, _delivery_warehouse_TypeOfWarehouse: null
  };

  const properties_all_np = {
    _delivery_courier_address: null, _delivery_courier_street: null, _delivery_courier_house: null,
    _delivery_courier_flat: null, _delivery_street_Ref: null, _delivery_city: null,
    _delivery_city_name: null, _delivery_city_Area: null, _delivery_city_Ref: null,
    _delivery_warehouse: null, _delivery_warehouse_zip: null, _delivery_warehouse_name: null,
    _delivery_warehouse_address: null, _delivery_warehouse_CityRef: null, _delivery_warehouse_Number: null,
    _delivery_warehouse_Ref: null, _delivery_warehouse_SettlementRef: null, _delivery_warehouse_TypeOfWarehouse: null
  };

  const properties_all_branch = {
    _delivery_warehouse: null, _delivery_warehouse_zip: null, _delivery_warehouse_name: null,
    _delivery_warehouse_address: null, _delivery_warehouse_CityRef: null, _delivery_warehouse_Number: null,
    _delivery_warehouse_Ref: null, _delivery_warehouse_SettlementRef: null, _delivery_warehouse_TypeOfWarehouse: null
  };

  const properties_all_courier = {
    _delivery_courier_street: null, _delivery_courier_house: null,
    _delivery_courier_flat: null, _delivery_street_Ref: null
  };

  const clearPropertiesMap = {
    all: properties_all_cart,
    existing: properties_all_np,
    branch: properties_all_branch,
    courier: properties_all_courier
  };

  updateCheckoutButtonState();

  /*== update cart attribute ==*/
  async function updateCartDeliveryAttr(data) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ attributes: data }),
      headers: { 'Content-Type': 'application/json' }
    });
    return response.json();
  }

  /*== Request API ==*/
  async function reqAPI(data) {
    try {
      const response = await fetch(endpointNP, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' }
      });
      return response.json();
    } catch (error) {
      console.error('NP API error:', error);
    }
  }

  function clearProperties(type) {
    const props = clearPropertiesMap[type];
    if (props) updateCartDeliveryAttr(props).catch(console.error);
  }

  let widgetStatus = false;

  const validation = async () => {
    try {
      const statusRes = await fetch('https://novaposhta.a.copycon.app/full?shop=' + Shopify.shop, {
        method: 'GET',
        cache: 'no-cache'
      });
      if (statusRes.ok) widgetStatus = true;

      const apiRes = await reqAPI({
        apiKey: NP.NP_API_KEY,
        modelName: 'Address',
        calledMethod: 'searchSettlements',
        methodProperties: { CityName: '01001', Limit: '1', Page: '1' }
      });

      if (apiRes && apiRes.success && widgetStatus) {
        mainAPI();
      } else {
        errorAPI();
      }
    } catch (error) {
      console.error('Validation error:', error);
      errorAPI();
    }
  };
  validation();

  let dataCities, dataWarehouses, dataStreet, addressCity, addressZip, addressStreet, addressBuild, addressFlat, warehouseData, address;

  function mainAPI() {

    if (document.querySelector('#type-other').checked) {
      updateCartDeliveryAttr(properties_all_cart);
      clearProperties('all');
      updateCheckoutButtonState();
    }

    /*== check selected delivery type in cart attribute ==*/
    fetch(`${NP.cartUrl}.json`).then(r => r.json()).then(data => {
      let isDelivery = false;
      wrapWarehouse.classList.add('d-none');
      wrapAddresses.classList.add('d-none');

      for (const key in data.attributes) {
        const value = data.attributes[key];
        if (!value) continue;
        properties[key] = value;
      }

      if (data.attributes._delivery_type) {
        isDelivery = true;
        deliveryVariants.setAttribute('data-variant', data.attributes._delivery_type);
        document.querySelector('input[type="radio"][name="id"][data-type=' + data.attributes._delivery_type + ']').checked = true;
        deliveryType = data.attributes._delivery_type;
        properties._delivery_type = deliveryType;
        if (deliveryType === 'courier') wrapAddresses.classList.remove('d-none');
        if (deliveryType === 'branch') wrapWarehouse.classList.remove('d-none');
      }

      if (!isDelivery) {
        wrapWarehouse.classList.remove('d-none');
        properties._delivery_type = deliveryType;
      }
    });

    /*== check changes delivery type ==*/
    deliveryTypes.forEach(function(el) {
      el.addEventListener('change', function() {
        deliveryType = this.getAttribute('data-type');
        wrapWarehouse.classList.add('d-none');
        wrapAddresses.classList.add('d-none');
        inputFields.forEach(function(e) { e.value = ''; });
        warehouseErrorEl.innerHTML = '';
        filterFields.forEach(function(f) {
          while (f.firstChild) { f.removeChild(f.firstChild); }
        });
        properties._delivery_type = deliveryType;
        if (deliveryType === 'branch') {
          properties._delivery_method = NP.methodBranch;
          wrapWarehouse.classList.remove('d-none');
        }
        if (deliveryType === 'courier') {
          properties._delivery_method = NP.methodCourier;
          wrapAddresses.classList.remove('d-none');
        }
        selectedDelivery.setAttribute('data-delivery', '');
        updateCheckoutButtonState();
      });
    });

    /*== text input clear ==*/
    document.querySelectorAll('.clear').forEach(function(el, index) {
      el.addEventListener('click', function() {
        const inputs = document.querySelectorAll('.form-group input');
        inputs[index].value = '';
        inputs[index].readOnly = false;
        inputs[index].focus();
        this.classList.add('d-none');

        if (index === 0) {
          document.querySelectorAll('.form-group').forEach(function(group) {
            group.querySelector('input').value = '';
            const clearBtn = group.querySelector('.clear');
            if (clearBtn) clearBtn.classList.add('d-none');
            group.querySelector('input').readOnly = false;
            clearList(listWarehouse);
            clearList(listCity);
            selectedDelivery.setAttribute('data-delivery', '');
          });
        }
        if (index === 1 || index === 2) {
          selectedDelivery.setAttribute('data-delivery', '');
        }
        filterFields.forEach(function(f) { clearList(f); });
        bodyNP.classList.remove('filter-active');
        warehouseErrorEl.innerHTML = '';
        updateCheckoutButtonState();
      });
    });

    function clearList(filter) {
      while (filter.firstChild) { filter.removeChild(filter.firstChild); }
    }

    function pointPrefix(data) {
      const prefixes = { Postomat: 'Поштомат', Branch: 'Відділення' };
      return prefixes[data] || data;
    }

    function stripslashes_n(str) {
      return str.replace(/'/g, 'ʹ');
    }

    /*== search city ==*/
    function searchCity() {
      let output_prev = 0;

      /* Quick City */
      document.querySelectorAll('a.quick-city-link').forEach(function(city) {
        city.addEventListener('click', function(e) {
          e.stopPropagation();
          clearCity.classList.remove('d-none');
          inputWarehouse.readOnly = false;
          document.querySelectorAll('.form-group').forEach(function(group) {
            if (!group.classList.contains('form-city')) {
              group.querySelector('input.form-control').value = '';
              const clearBtn = group.querySelector('.clear');
              if (clearBtn) clearBtn.classList.add('d-none');
            }
          });
          inputCity.readOnly = true;
          addressCity = this.getAttribute('data-main');
          inputCity.value = this.getAttribute('data-present');
          properties._delivery_city = this.getAttribute('data-present');
          properties._delivery_city_name = this.getAttribute('data-main');
          properties._delivery_city_Ref = this.getAttribute('data-ref');
          updateCartDeliveryAttr(properties).catch(console.error);
          clearList(listCity);

          const ref = this.getAttribute('data-ref');
          if (deliveryType === 'branch' && ref) {
            reqAPI({
              apiKey: NP.NP_API_KEY, modelName: 'Address', calledMethod: 'getWarehouses',
              methodProperties: { CityRef: ref }
            }).then(function(res) { dataWarehouses = res.data; searchWarehouse(dataWarehouses); }).catch(console.error);
          } else if (deliveryType === 'courier' && ref) {
            searchStreet(ref);
          }
        });
      });

      if (inputCity.getAttribute('data-ref').length > 0) {
        const cityRef = inputCity.getAttribute('data-ref');
        if (deliveryType === 'branch') {
          inputWarehouse.readOnly = false;
          reqAPI({
            apiKey: NP.NP_API_KEY, modelName: 'Address', calledMethod: 'getWarehouses',
            methodProperties: { CityRef: cityRef }
          }).then(function(res) { dataWarehouses = res.data; searchWarehouse(dataWarehouses); }).catch(console.error);
        } else if (deliveryType === 'courier') {
          inputStreet.readOnly = false;
          searchStreet(cityRef);
        }
      }

      inputCity.addEventListener('keyup', function(event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || inputCity.readOnly) return;

        const searchField = this.value;
        inputWarehouse.value = inputStreet.value = '';
        inputWarehouse.readOnly = false;
        listWarehouse.classList.remove('active');
        clearList(listWarehouse);
        document.getElementById('street_filter').classList.remove('active');
        clearCity.classList.remove('d-none');

        if (searchField === '' || searchField === ' ') {
          clearList(listCity);
          bodyNP.classList.remove('filter-active');
          cityErrorEl.innerHTML = '';
          clearCity.classList.add('d-none');
          output_prev = 0;
          return;
        }

        reqAPI({
          apiKey: NP.NP_API_KEY, modelName: 'Address', calledMethod: 'searchSettlements',
          methodProperties: { CityName: searchField, Limit: '150', Page: '1', Warehouse: '1' }
        }).then(function(res) {
          clearList(listCity);
          dataCities = res.data[0].Addresses;
          if (dataCities.length > 0) {
            clearList(listCity);
            cityErrorEl.innerHTML = '';
          } else {
            if (output_prev > 0) cityErrorEl.innerHTML = NP.alertCity;
          }
          renderCities();
        }).catch(function() {
          clearList(listCity);
          cityErrorEl.innerHTML = NP.alertKeyboard;
        });

        function renderCities() {
          clearList(listCity);
          let output = '';

          if (dataCities && dataCities.length > 0) {
            dataCities.forEach(function(val) {
              const linkClass = (val.Warehouses == 0 && deliveryType === 'branch') ? 'd-none' : '';
              const cityDataVal = JSON.parse(stripslashes_n(JSON.stringify(val)));
              output += `<a data-main='${cityDataVal.MainDescription}' data-present='${cityDataVal.Present}' data-ref='${cityDataVal.DeliveryCity}' class='city-link ${linkClass}' href='javascript:void(0)' style='display:block;'>${val.Present}</a>`;
            });
          }

          listCity.insertAdjacentHTML('afterbegin', output);

          if (output_prev > 0) {
            bodyNP.classList.add('filter-active');
            document.getElementById('city_filter').classList.add('active');
          }

          document.querySelectorAll('a.city-link').forEach(function(city) {
            city.addEventListener('click', function(e) {
              e.stopPropagation();
              bodyNP.classList.remove('filter-active');
              cityErrorEl.innerHTML = '';
              clearCity.classList.remove('d-none');
              inputCity.readOnly = true;

              addressCity = this.getAttribute('data-main');
              inputCity.value = this.getAttribute('data-present');
              properties._delivery_city = this.getAttribute('data-present');
              properties._delivery_city_name = this.getAttribute('data-main');
              properties._delivery_city_Ref = this.getAttribute('data-ref');
              updateCartDeliveryAttr(properties).catch(console.error);
              clearList(listCity);

              const ref = this.getAttribute('data-ref');
              if (deliveryType === 'branch' && ref) {
                reqAPI({
                  apiKey: NP.NP_API_KEY, modelName: 'Address', calledMethod: 'getWarehouses',
                  methodProperties: { CityRef: ref }
                }).then(function(res) { dataWarehouses = res.data; searchWarehouse(dataWarehouses); }).catch(console.error);
              } else if (deliveryType === 'courier' && ref) {
                searchStreet(ref);
              }
            });
          });
          output_prev = output.length;
        }
      });
    }

    /*== search branch/postomat ==*/
    function searchWarehouse(data) {
      wrapWarehouse.classList.remove('d-none');
      const filter = document.querySelector('#warehouse_filter');

      if (data.length > 0) {
        inputWarehouse.addEventListener('keyup', function(event) {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') return;

          clearWarehouse.classList.remove('d-none');
          const searchField = this.value;
          if (searchField === '') {
            clearList(filter);
            return;
          }

          const regex = new RegExp(searchField, 'i');
          let output = '';

          data.forEach(function(val) {
            if (val.Description.search(regex) !== -1) {
              output += `<a data-val='${stripslashes_n(JSON.stringify(val))}' class='warehouse-link' href='javascript:void(0)' style='display:block;'>${val.Description}</a>`;
            }
          });

          updateCheckoutButtonState();

          if (output.length > 0) {
            clearList(filter);
            warehouseErrorEl.innerHTML = '';
          } else {
            warehouseErrorEl.innerHTML = NP.alertWarehouse;
          }

          filter.insertAdjacentHTML('afterbegin', output);
          const warehousesLinks = document.querySelectorAll('a.warehouse-link');
          if (warehousesLinks.length > 0) {
            document.getElementById('warehouse_filter').classList.add('active');
          }

          warehousesLinks.forEach(function(warehouse) {
            warehouse.addEventListener('click', function(e) {
              e.stopPropagation();
              warehouseData = JSON.parse(this.getAttribute('data-val'));
              warehouseErrorEl.innerHTML = '';
              addressStreet = warehouseData.Description;
              inputWarehouse.value = addressStreet;
              inputWarehouse.readOnly = true;
              addressZip = '00000';
              addressBuild = addressFlat = '';
              clearList(filter);

              properties._delivery_warehouse = addressStreet;
              properties._delivery_warehouse_zip = addressZip;
              properties._delivery_warehouse_name = pointPrefix(warehouseData.CategoryOfWarehouse) + ':' + warehouseData.Number;
              properties._delivery_warehouse_address = warehouseData.ShortAddress;
              properties._delivery_warehouse_CityRef = warehouseData.CityRef;
              properties._delivery_warehouse_Number = warehouseData.Number;
              properties._delivery_warehouse_Ref = warehouseData.Ref;
              properties._delivery_warehouse_SettlementRef = warehouseData.SettlementRef;
              properties._delivery_warehouse_TypeOfWarehouse = warehouseData.TypeOfWarehouse;

              updateCartDeliveryAttr(properties).catch(console.error);
              selectedDelivery.setAttribute('data-delivery', properties._delivery_city + ', ' + properties._delivery_warehouse_name);
              updateCheckoutButtonState();
            });
          });
        });
      } else {
        updateCheckoutButtonState();
      }
    }

    /*== search street ==*/
    function searchStreet(city) {
      wrapAddresses.classList.remove('d-none');
      dataStreet = false;
      let streetPref;
      let output_prev = 0;

      inputStreet.addEventListener('keyup', function(event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') return;

        clearStreet.classList.remove('d-none');
        const filter = document.querySelector('#street_filter');
        const searchField = this.value;

        if (searchField === '' || searchField.includes('&#8291;') || searchField === ' ') {
          clearList(filter);
          clearStreet.classList.add('d-none');
          streetErrorEl.innerHTML = '';
          return;
        }

        let queryStr = searchField;
        if (streetPref && searchField.includes(streetPref)) {
          queryStr = searchField.split(streetPref)[1];
          this.value = queryStr;
        }

        reqAPI({
          apiKey: NP.NP_API_KEY, modelName: 'Address', calledMethod: 'getStreet',
          methodProperties: { CityRef: city, FindByString: queryStr, Page: '1', Limit: '' }
        }).then(function(res) {
          dataStreet = res.data;
          renderStreets(filter);
        }).catch(function() {
          clearList(filter);
          streetErrorEl.innerHTML = NP.alertKeyboard;
        });

        function renderStreets(filter) {
          let output = '';
          dataStreet.forEach(function(val) {
            output += `<a data-ref="${val.Ref}" data-street="${val.StreetsType}${val.Description}" data-prefix="${val.StreetsType}" class="street-link" href="javascript:void(0)" style="display:block;">${val.StreetsType}${val.Description}</a>`;
          });

          if (dataStreet.length > 0) {
            clearList(filter);
            streetErrorEl.innerHTML = '';
          } else {
            if (output_prev > 0) streetErrorEl.innerHTML = NP.alertStreet;
          }

          filter.insertAdjacentHTML('afterbegin', output);

          const streetLinks = document.querySelectorAll('a.street-link');
          if (streetLinks.length > 0) {
            document.getElementById('street_filter').classList.add('active');
          }

          streetLinks.forEach(function(street) {
            street.addEventListener('click', function(e) {
              e.stopPropagation();
              addressStreet = this.getAttribute('data-street');
              inputStreet.value = this.getAttribute('data-street');
              streetPref = this.getAttribute('data-prefix');
              addressZip = '00000';
              clearList(filter);

              properties._delivery_courier_address = addressStreet;
              properties._delivery_courier_street = addressStreet;
              properties._delivery_street_Ref = this.getAttribute('data-ref');

              updateCartDeliveryAttr(properties).catch(console.error);
              selectedDelivery.setAttribute('data-delivery', properties._delivery_city + ', ' + properties._delivery_courier_street);
              updateCheckoutButtonState();
            });
          });
          output_prev = output.length;
        }
      });

      inputStreet.addEventListener('focusout', function() {
        if (this.value && this.value !== '') {
          addressStreet = 'вул.' + this.value;
          properties._delivery_courier_address = addressStreet;
          properties._delivery_courier_street = addressStreet;
        }
      });
    }

    /*== input build ==*/
    inputBuild.addEventListener('keyup', function() {
      addressBuild = ', буд.' + this.value;
    });
    inputBuild.addEventListener('focusout', function() {
      addressStreet = addressStreet + '' + addressBuild;
      properties._delivery_courier_address = addressStreet;
      properties._delivery_courier_house = addressBuild;
    });

    /*== input flat ==*/
    inputFlat.addEventListener('keyup', function() {
      addressFlat = ', кв.' + this.value;
    });
    inputFlat.addEventListener('focusout', function() {
      addressStreet = addressStreet + '' + addressFlat;
      properties._delivery_courier_address = addressStreet;
      properties._delivery_courier_flat = addressFlat;
    });

    /*== error message ==*/
    function addErrorMessage() {
      const errorContainer = document.querySelector('.cart-terms .alert-danger');
      if (!errorContainer) return false;
      if (!errorContainer.getAttribute('added-text')) {
        errorContainer.innerHTML += ` ${translations?.shipping_method?.title}`;
        errorContainer.setAttribute('added-text', 'true');
        return true;
      }
    }

    const errorInterval = setInterval(() => {
      const isSet = addErrorMessage();
      if (isSet !== false) clearInterval(errorInterval);
    }, 100);

    /*== checkout ==*/
    NP.checkoutButton.addEventListener('click', async function(e) {
      if (this.dataset.npBlocked === 'true') {
        e.preventDefault();
        e.stopPropagation();
        showCheckoutTooltip(this.dataset.npTooltip || getCheckoutValidationMessage());
        if (this.dataset.npBlockedReason === 'delivery') {
          openDeliveryWidget();
          focusInvalidDeliveryField();
        }
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      this.disabled = false;

      if (document.querySelector('#type-nova-poshta').checked) {
        addressStreet = addressStreet || '';
        addressCity = addressCity || properties._delivery_city_name;
        addressZip = '00000';
        address = {
          first_name: ' ',
          last_name: ' ',
          address1: (deliveryType === 'branch') ? properties._delivery_warehouse : addressStreet + ' (' + NP.methodCourier + ')',
          zip: addressZip,
          city: addressCity,
          country: country
        };
      } else {
        address = { address1: ' ', zip: ' ', city: ' ', country: ' ' };
      }

      setTimeout(function() {
        fetch(`${NP.cartUrl}.json`).then(r => r.json()).then(data => {
          const pairs = [];
          for (const key in address) {
            if (!address[key]) continue;
            pairs.push(`checkout[shipping_address][${key}]=${address[key]}`);
          }

          let query = pairs.join('&');
          if (data.note && data.note != null) {
            query += `&note=${data.note}`;
          }
          window.location.href = `/cart/checkout?${query}`;
        });
      }, 200);
    });

    NP.NovaPoshtaLoad = true;
    searchCity();
  }

  /*== Error API ==*/
  function errorAPI() {
    console.error('Nova Poshta API Error');
  }
}
let npTooltipTimeout

function formatMoneyValue(cents) {
  if (window.FoxTheme && FoxTheme.Currency && FoxTheme.Currency.formatMoney) {
    const moneyFormat = NP.minimumOrderMoneyFormat || FoxTheme.settings.moneyFormat;

    return FoxTheme.Currency.formatMoney(cents, moneyFormat)
      .replace(/<[^>]*>/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  return `${(cents / 100).toFixed(0)}`;
}

function getMinimumOrderValidationMessage() {
  const minimumOrderAmountCents = Number(NP.minimumOrderAmountCents || 0);
  const cartTotalPriceCents = Number(NP.cartTotalPriceCents || 0);

  if (!minimumOrderAmountCents || cartTotalPriceCents >= minimumOrderAmountCents) return '';

  const minimum = formatMoneyValue(minimumOrderAmountCents);
  const remaining = formatMoneyValue(minimumOrderAmountCents - cartTotalPriceCents);

  return (NP.alertMinimumOrder || '')
    .replace('[minimum]', minimum)
    .replace('[remaining]', remaining);
}

function isNovaPoshtaSelected() {
  const novaPoshtaOption = document.querySelector('#type-nova-poshta')
  if (!novaPoshtaOption) return false

  return NP.onlyNP || novaPoshtaOption.checked
}

function getActiveDeliveryType() {
  const checkedDeliveryType = document.querySelector('input[type="radio"][name="id"]:checked')
  return checkedDeliveryType ? checkedDeliveryType.getAttribute('data-type') : 'branch'
}

function getDeliveryValidationMessage() {
  if (!isNovaPoshtaSelected()) return ''

  const cityInput = document.querySelector('input.form-control.input-city')
  const warehouseInput = document.querySelector('input.form-control.input-warehouse')
  const streetInput = document.querySelector('input.form-control.input-street')
  const cityValue = cityInput ? cityInput.value.trim() : ''
  const warehouseValue = warehouseInput ? warehouseInput.value.trim() : ''
  const streetValue = streetInput ? streetInput.value.trim() : ''
  const deliveryType = getActiveDeliveryType()

  if (!cityValue) return NP.alertDelivery
  if (deliveryType === 'courier') {
    if (!streetValue) return NP.alertDelivery
  } else if (!warehouseValue) {
    return NP.alertDelivery
  }

  return ''
}

function getCheckoutValidationState() {
  const minimumOrderMessage = getMinimumOrderValidationMessage()
  if (minimumOrderMessage) {
    return {
      isBlocked: true,
      reason: 'minimum-order',
      message: minimumOrderMessage
    }
  }

  const deliveryMessage = getDeliveryValidationMessage()
  if (deliveryMessage) {
    return {
      isBlocked: true,
      reason: 'delivery',
      message: deliveryMessage
    }
  }

  return {
    isBlocked: false,
    reason: '',
    message: ''
  }
}

function getCheckoutValidationMessage() {
  return getCheckoutValidationState().message
}

function refreshCheckoutButtonReference() {
  const checkoutButton = document.querySelector(NP.selectorCheckoutButton)
  if (checkoutButton) {
    NP.checkoutButton = checkoutButton
  }

  return NP.checkoutButton
}

function ensureCheckoutTooltip() {
  refreshCheckoutButtonReference()
  if (!NP.checkoutButton || !NP.checkoutButton.parentNode) return null

  let tooltipWrap = NP.checkoutButton.closest('.np-checkout-tooltip-wrap')
  if (!tooltipWrap) {
    tooltipWrap = document.createElement('div')
    tooltipWrap.className = 'np-checkout-tooltip-wrap tooltip--manual'
    tooltipWrap.setAttribute('data-tooltip', '')
    NP.checkoutButton.parentNode.insertBefore(tooltipWrap, NP.checkoutButton)
    tooltipWrap.appendChild(NP.checkoutButton)
  }

  let tooltip = tooltipWrap.querySelector('.tooltip')
  if (!tooltip) {
    tooltip = document.createElement('span')
    tooltip.className = 'tooltip pointer-events-none'
    tooltip.id = 'np-checkout-tooltip'
    tooltip.setAttribute('role', 'status')
    tooltip.setAttribute('aria-live', 'polite')
    tooltipWrap.appendChild(tooltip)
  }

  NP.checkoutButton.setAttribute('aria-describedby', tooltip.id)

  return tooltip
}

function hideCheckoutTooltip() {
  const tooltipWrap = document.querySelector('.np-checkout-tooltip-wrap')
  if (!tooltipWrap) return

  tooltipWrap.classList.remove('tooltip--is-visible')
  window.clearTimeout(npTooltipTimeout)
}

function showCheckoutTooltip(message) {
  const tooltip = ensureCheckoutTooltip()
  if (!tooltip || !message) return

  tooltip.textContent = message
  tooltip.parentNode.classList.add('tooltip--is-visible')
  window.clearTimeout(npTooltipTimeout)
  npTooltipTimeout = window.setTimeout(() => {
    tooltip.parentNode.classList.remove('tooltip--is-visible')
  }, 2600)
}

function setCheckoutButtonState(isBlocked) {
  refreshCheckoutButtonReference()
  if (!NP.checkoutButton) return

  ensureCheckoutTooltip()
  const validationState = isBlocked ? getCheckoutValidationState() : { reason: '', message: '' }

  NP.checkoutButton.classList.toggle('disabled', isBlocked)
  NP.checkoutButton.classList.toggle('np-checkout-blocked', isBlocked)
  NP.checkoutButton.setAttribute('aria-disabled', isBlocked ? 'true' : 'false')
  NP.checkoutButton.dataset.npBlocked = isBlocked ? 'true' : 'false'
  NP.checkoutButton.dataset.npBlockedReason = validationState.reason
  NP.checkoutButton.dataset.npTooltip = validationState.message
  NP.checkoutButton.disabled = false

  if (!isBlocked) hideCheckoutTooltip()

  controlHover()
}

function updateCheckoutButtonState() {
  const validationState = getCheckoutValidationState()
  setCheckoutButtonState(validationState.isBlocked)
}

function openDeliveryWidget() {
  const deliveryLegend = document.querySelector('#deliveryVariants legend')
  if (deliveryLegend && !deliveryLegend.classList.contains('poshta-open')) {
    deliveryLegend.classList.add('poshta-open')
  }

  const novaPoshtaOption = document.querySelector('#type-nova-poshta')
  if (novaPoshtaOption && !novaPoshtaOption.checked) {
    novaPoshtaOption.checked = true
  }
}

function focusInvalidDeliveryField() {
  const cityInput = document.querySelector('input.form-control.input-city')
  const warehouseInput = document.querySelector('input.form-control.input-warehouse')
  const streetInput = document.querySelector('input.form-control.input-street')
  const deliveryType = getActiveDeliveryType()
  let invalidInput = null

  if (!cityInput || !cityInput.value.trim()) {
    invalidInput = cityInput
  } else if (deliveryType === 'courier') {
    invalidInput = !streetInput || !streetInput.value.trim() ? streetInput : null
  } else {
    invalidInput = !warehouseInput || !warehouseInput.value.trim() ? warehouseInput : null
  }

  if (!invalidInput) return

  invalidInput.removeAttribute('readonly')
  invalidInput.focus({ preventScroll: true })
  if (typeof invalidInput.select === 'function') invalidInput.select()
}

function initWidgetState() {
  document.querySelector('.warehouse-wrap').classList.add('d-none');
  document.querySelector('.address-wrap').classList.add('d-none');

  const cityInput = document.querySelector('input.form-control.input-city');
  const warehouseInput = document.querySelector('input.form-control.input-warehouse');

  if (cityInput.value.length > 0) {
    if (document.querySelector('input[type="radio"][name="id"][data-type="branch"]').checked) {
      document.querySelector('.warehouse-wrap').classList.remove('d-none');
    } else {
      document.querySelector('.address-wrap').classList.remove('d-none');
    }
  }

  updateCheckoutButtonState();
  if (!NP.NovaPoshtaLoad) {
    NovaPoshtaMain();
    NP.NovaPoshtaLoad = true;
  }
}

function widget_load() {
  if (!NP.onlyNP) {
    document.querySelectorAll('input[type="radio"][name="delivery"]').forEach(function(el) {
      el.addEventListener('change', function() {
        if (this.getAttribute('data-type') === 'nova-poshta') {
          initWidgetState();
        } else {
          NovaPoshtaMain();
          updateCheckoutButtonState();
        }
      });
    });
  } else {
    initWidgetState();
  }
}

function addHover() {
  const deliveryLegend = document.querySelector('#deliveryVariants legend');
  if (deliveryLegend) deliveryLegend.classList.add('button-hover');
  if (NP.checkoutButton && NP.checkoutButton.dataset.npBlocked === 'true') {
    showCheckoutTooltip(NP.checkoutButton.dataset.npTooltip || getCheckoutValidationMessage());
  }
}

function removeHover() {
  const deliveryLegend = document.querySelector('#deliveryVariants legend');
  if (deliveryLegend) deliveryLegend.classList.remove('button-hover');
  hideCheckoutTooltip();
}

function controlHover() {
  if (NP.checkoutButton.classList.contains('disabled')) {
    NP.checkoutButton.addEventListener('mouseover', addHover, true);
    NP.checkoutButton.addEventListener('mouseout', removeHover, true);
  } else {
    NP.checkoutButton.removeEventListener('mouseover', addHover, true);
    NP.checkoutButton.removeEventListener('mouseout', removeHover, true);
  }
}

function nphtml() {
  window.NP.checkoutButton = document.querySelector(NP.selectorCheckoutButton);
  ensureCheckoutTooltip();
  setCheckoutButtonState(true);

  const elementParent = document.querySelector(NP.selectorParent);
  elementParent.classList.add('poshta-content');
  elementParent.insertAdjacentHTML('afterbegin', NP.widgetHTML);

  // Prevent clicks inside the widget from closing the cart drawer.
  // The theme's CartDrawer uses document-level "click" listener (handleOutsideClick)
  // that checks cartDrawerInner.contains(event.target). When dropdown items are
  // removed from DOM after selection, contains() returns false and drawer closes.
  // We patch handleOutsideClick to also check if click originated inside #nova-poshta.
  const cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl && cartDrawerEl.handleOutsideClick) {
    const originalHandler = cartDrawerEl.handleOutsideClick;
    cartDrawerEl.handleOutsideClick = function(event) {
      const novaPoshtaWidget = document.getElementById('nova-poshta');
      if (novaPoshtaWidget && (novaPoshtaWidget.contains(event.target) || novaPoshtaWidget === event.target)) {
        return;
      }
      // Also check if target was removed from DOM (clicked dropdown item)
      if (!document.body.contains(event.target)) {
        return;
      }
      return originalHandler.call(this, event);
    };
    // Re-register the patched handler on document
    document.removeEventListener('click', originalHandler);
    document.addEventListener('click', cartDrawerEl.handleOutsideClick);
  }

  window.selectedDelivery = document.querySelector('.selected-delivery');

  updateCheckoutButtonState();

  widget_load();
}

document.addEventListener('cart:updated', function(event) {
  if (!event.detail || !event.detail.cart) return

  NP.cartTotalPriceCents = event.detail.cart.total_price
  refreshCheckoutButtonReference()
  updateCheckoutButtonState()
})
